import Link, { LinkProps } from 'next/link';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import { Routes } from '../../util/routes';

export const CommunityNavbar = () => {
  return (
    <div className="flex items-center justify-center space-x-20 border-b border-black/10 bg-white py-4">
      <NavButton href={Routes.community()} label="Main" legacyBehavior />
      <NavButton href={Routes.blog()} label="Blog" legacyBehavior />
      <NavButton href={Routes.guides()} label="Guides" legacyBehavior />
      {/* JOV-5434: jobs-api decommissioned, hide Jobs nav link */}
      {/* <NavButton href={Routes.jobs()} label="Jobs" legacyBehavior /> */}
      <NavButton href={Routes.ir35()} label="IR35 assessment" legacyBehavior />
    </div>
  );
};

type NavButtonProps = LinkProps & {
  label: string;
};

export const NavButton = ({ label, href }: NavButtonProps) => {
  const router = useRouter();

  const isActive =
    router.asPath === href.toString() ||
    router.asPath.startsWith(href.toString());

  const className = clsx(
    'nav-link text-base group hover:text-gray-900 font-semibold numeric-font-fix flex flex-col items-center',
    {
      active: isActive,
    }
  );

  return (
    <Link aria-label={label} href={href} className={className}>
      <span>{label}</span>
      <span
        className={clsx(
          ' group-hover:bg-brand-primary/50 h-[6px] w-[6px] rounded-full transition-colors',
          { 'bg-brand-primary': isActive }
        )}
      ></span>
    </Link>
  );
};
